import React, { useEffect } from "react";

const HistoryModal = ({ isOpen, onClose, exercise_history, currentTrainingName }) => {
  useEffect(() => {
    if (!isOpen) return;
    document.body.classList.add("modal-open");
    return () => document.body.classList.remove("modal-open");
  }, [isOpen]);

  const formatDate = (dateStr) => {
    const date = new Date(dateStr);
    return date.toLocaleDateString("en-US", {
      day: "2-digit",
      month: "short",
      year: "numeric",
    });
  };

  const hasHistory = exercise_history && exercise_history.length > 0;

  return isOpen ? (
    <div className="modal fade show d-block" tabIndex="-1" style={{ backgroundColor: "rgba(0,0,0,0.5)" }}>
      <div className="modal-dialog modal-md modal-dialog-centered">
        <div className="modal-content">
          <div className="modal-header justify-content-center">
            <h5 className="modal-title">History</h5>
            <button type="button" className="btn-close" onClick={onClose}></button>


          </div>
          <div className="modal-body"> 
            <h6 style={{ textAlign: "center" }}>{currentTrainingName}</h6>
{Array.isArray(exercise_history) ? (
  exercise_history.length > 0 ? (
    <div className="table-responsive">
      <table className="table table-xs">
        <thead className="table-light">
          <tr>
            <th style={{ width: "100px", backgroundColor: "white", textAlign: "left", border: 'none' }}></th>
            <th style={{ width: "100px", backgroundColor: "white", textAlign: "left", border: 'none' }}></th>
          </tr>
        </thead>
        <tbody>
          {exercise_history.map((entry, i) => (
            <tr key={i}>
              <td style={{ backgroundColor: "white", textAlign: "left", border: 'none' }}>
                {entry.weight} kg X {entry.reps}
              </td>
              <td style={{ backgroundColor: "white", textAlign: "left", border: 'none' }}>
                WEEK {entry.week_number} - DAY {entry.day_number}
                <br />
                {formatDate(entry.date)}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  ) : (
    <div className="text-center text-muted">No history found</div>
  )
) : (
  <div className="text-center text-muted">Loading...</div>
)}

          </div>
        </div>
      </div>
    </div>
  ) : null;
};

export default HistoryModal;
